module.exports = __webpack_public_path__ + "img/ScottishFold.b552b78e.svg";